var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForgotDetailsLoader = function SvgForgotDetailsLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#forgot-details-loader_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.666,
    d: "M18.843 12.611a7.498 7.498 0 1 1-4.001-7.854"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "forgot-details-loader_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.128 0 19.748 3.128-3.128 19.748L0 19.748z"
  })))));
};
export default SvgForgotDetailsLoader;